/* ==========================================================================
   Scroll-triggered animations — IntersectionObserver
   ========================================================================== */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-on-scroll--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  function observe() {
    document.querySelectorAll('.animate-on-scroll').forEach(function (el) {
      if (!el.classList.contains('animate-on-scroll--visible')) {
        observer.observe(el);
      }
    });
  }

  /* Initial pass + re-observe after Shopify section rendering */
  observe();
  document.addEventListener('shopify:section:load', observe);
})();
